import { render, staticRenderFns } from "./RegisterStepper.vue?vue&type=template&id=53786f47&scoped=true"
import script from "./RegisterStepper.vue?vue&type=script&lang=js"
export * from "./RegisterStepper.vue?vue&type=script&lang=js"
import style0 from "./RegisterStepper.vue?vue&type=style&index=0&id=53786f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53786f47",
  null
  
)

export default component.exports